const GOOGLE_MAPS_SEARCH_BASE =
  'https://www.google.com/maps/search/?api=1&query=';

function isWithinPeru(latitude: number, longitude: number): boolean {
  return (
    latitude >= -18.35 &&
    latitude <= -0.03 &&
    longitude >= -81.35 &&
    longitude <= -68.65
  );
}

/**
 * Builds a Google Maps search URL.
 * Uses decimal coordinates when they fall within Peru's bounding box;
 * otherwise falls back to a text-encoded address search.
 */
export function buildGoogleMapsUrl(
  latitude: number,
  longitude: number,
  fallbackAddress: string,
): string {
  if (isWithinPeru(latitude, longitude)) {
    return `${GOOGLE_MAPS_SEARCH_BASE}${latitude},${longitude}`;
  }
  return `${GOOGLE_MAPS_SEARCH_BASE}${encodeURIComponent(fallbackAddress)}`;
}
